export function getPermissionsConfig(isPulseRelaunchActive: boolean): any {
  return {
    title: $localize`User permissions`,
    subtitle: $localize`Learn more about roles and their permissions`,
    sections: [
      {
        title: $localize`Reference permissions`,
        img: 'https://assets.xref.com/omni/shared/new_reference_icon.svg',
        table_content: {
          headers: [
            $localize`Features`,
            $localize`Administrator`,
            $localize`Requestor`,
            $localize`Contributor`,
          ],
          body: [
            [
              [$localize`Settings`, '', '', ''],
              [$localize`Reference settings`, $localize`Yes`, '-', '-'],
              [$localize`User management`, $localize`Yes‡`, '-', '-'],
            ],
            [
              [$localize`Requests`, '', '', ''],
              [
                $localize`Send requests`,
                $localize`Yes`,
                $localize`Yes*`,
                $localize`Yes*`,
              ],
              [
                $localize`View requests`,
                $localize`All requests`,
                $localize`Limited requests*`,
                $localize`Own requests*`,
              ],
              [
                $localize`Manage requests`,
                $localize`All requests`,
                $localize`Limited requests*`,
                $localize`Own requests*`,
              ],
            ],
            [
              [$localize`People`, '', '', ''],
              [
                $localize`View profile`,
                $localize`Yes†`,
                $localize`Yes†`,
                $localize`Yes†`,
              ],
              [$localize`Edit profile`, $localize`Yes`, $localize`Yes`, '-'],
            ],
            [
              [$localize`Surveys`, '', '', ''],
              [$localize`Create surveys`, $localize`Yes`, $localize`Yes`, '-'],
              [
                $localize`View surveys`,
                $localize`All surveys`,
                $localize`All surveys*`,
                $localize`All surveys*`,
              ],
              [
                $localize`Manage surveys`,
                $localize`All surveys`,
                $localize`Own surveys*`,
                '-',
              ],
            ],
            ...(isPulseRelaunchActive ? [
              [
                [$localize`Generate report`, '', '', '', ''],
                [
                  $localize`Talent pool`,
                  $localize`Yes`,
                  $localize`Yes`,
                  $localize`Yes`,
                ]
              ]
            ] : [])
          ],
        },
        id: 'reference',
        footerItems: [
          "*With survey permission.",
          "† Offering a restricted view of requests for all products.",
          "‡ Only for the product they have access to"
        ]
      },
      {
        title: $localize`Pulse permissions`,
        img: 'https://assets.xref.com/omni/shared/pulse_icon.svg',
        table_content: {
          headers: [
            $localize`Features`,
            $localize`Administrator`,
            $localize`Requestor`,
            $localize`Contributor`,
            $localize`Analyst`,
          ],
          body: [
            [
              [$localize`Settings`, '', '', '', ''],
              [$localize`Pulse settings`, $localize`Yes`, '-', '-', '-'],
              [$localize`User management`, $localize`Yes‡`, '-', '-', '-'],
            ],
            [
              [$localize`Requests`, '', '', '', ''],
              [
                $localize`Send requests`,
                $localize`Yes`,
                $localize`Yes*`,
                $localize`Yes*`,
                '-',
              ],
              [
                $localize`View requests`,
                $localize`All requests`,
                $localize`Limited requests*`,
                $localize`Own requests*`,
                '-',
              ],
              [
                $localize`Manage requests`,
                $localize`All requests`,
                $localize`Limited requests*`,
                $localize`Own requests*`,
                '-',
              ],
            ],
            [
              [$localize`People`, '', '', '', ''],
              [
                $localize`View profile`,
                $localize`Yes†`,
                $localize`Yes†`,
                $localize`Yes†`,
                $localize`-`,
              ],
              [
                $localize`Edit profile`,
                $localize`Yes`,
                $localize`Yes`,
                '-',
                '-',
              ],
            ],
            [
              [$localize`Insights`, '', '', '', ''],
              [
                $localize`View organisation-wide aggregated insights`,
                $localize`Yes`,
                $localize`Yes`,
                $localize`Yes`,
                $localize`Yes`,
              ],
              [
                $localize`View insights`,
                $localize`Yes`,
                $localize`Yes*`,
                $localize`Yes*`,
                $localize`Yes*`,
              ],
            ],
            [
              [$localize`Surveys`, '', '', '', ''],
              [
                $localize`Create surveys`,
                $localize`Yes`,
                $localize`Yes`,
                '-',
                '-',
              ],
              [
                $localize`View surveys`,
                $localize`All surveys`,
                $localize`All surveys*`,
                $localize`All surveys*`,
                $localize`All surveys*`,
              ],
              [
                $localize`Manage surveys`,
                $localize`All surveys`,
                $localize`Own surveys*`,
                '-',
                '-',
              ],
            ],
            ...(isPulseRelaunchActive ? [
              [
                [$localize`Generate report`, '', '', '', ''],
                [
                  $localize`Pulse report`,
                  $localize`All surveys`,
                  $localize`All surveys*`,
                  $localize`All surveys*`,
                  $localize`All surveys*`
                ],
                [
                  $localize`Talent pool`,
                  $localize`Yes`,
                  $localize`Yes`,
                  $localize`Yes`,
                  $localize`Yes`,
                ]
              ]
            ] : [])
          ],
        },
        id: 'pulse',
        footerItems: [
          "*With survey permission.",
          "† Offering a restricted view of requests for all products.",
          "‡ Only for the product they have access to"
        ]
      },
      {
        title: $localize`Exit permissions`,
        img: 'https://assets.xref.com/omni/shared/exit_logo.svg',
        table_content: {
          headers: [
            $localize`Features`,
            $localize`Administrator`,
            $localize`Requestor`,
            $localize`Contributor`,
            $localize`Analyst`,
          ],
          body: [
            [
              [$localize`Settings`, '', '', '', ''],
              [$localize`Exit settings`, $localize`Yes`, '-', '-', '-'],
              [$localize`User management`, $localize`Yes‡`, '-', '-', '-'],
            ],
            [
              [$localize`Requests`, '', '', '', ''],
              [
                $localize`Send requests`,
                $localize`Yes`,
                $localize`Yes*`,
                $localize`Yes*`,
                '-',
              ],
              [
                $localize`View requests`,
                $localize`All requests`,
                $localize`Limited requests*`,
                $localize`Own requests*`,
                '-',
              ],
              [
                $localize`Manage requests`,
                $localize`All requests`,
                $localize`Limited requests*`,
                $localize`Own requests*`,
                '-',
              ],
            ],
            [
              [$localize`People`, '', '', '', ''],
              [
                $localize`View profile`,
                $localize`Yes†`,
                $localize`Yes†`,
                $localize`Yes†`,
                '-',
              ],
              [
                $localize`Edit profile`,
                $localize`Yes`,
                $localize`Yes`,
                '-',
                '-',
              ],
            ],
            [
              [$localize`Insights`, '', '', '', ''],
              [
                $localize`View organisation-wide aggregated insights`,
                $localize`Yes`,
                $localize`Yes`,
                $localize`Yes`,
                $localize`Yes`,
              ],
              [
                $localize`View insights`,
                $localize`Yes`,
                $localize`Yes*`,
                $localize`Yes*`,
                $localize`Yes*`,
              ],
            ],
            [
              [$localize`Surveys`, '', '', '', ''],
              [
                $localize`Create surveys`,
                $localize`Yes`,
                $localize`Yes`,
                '-',
                '-',
              ],
              [
                $localize`View surveys`,
                $localize`All surveys`,
                $localize`All surveys*`,
                $localize`All surveys*`,
                $localize`All surveys*`,
              ],
              [
                $localize`Manage surveys`,
                $localize`All surveys`,
                $localize`Own surveys*`,
                '-',
                '-',
              ],
            ],
            ...(isPulseRelaunchActive ? [
              [
                [$localize`Generate report`, '', '', '', ''],
                [
                  $localize`Talent pool`,
                  $localize`Yes`,
                  $localize`Yes`,
                  $localize`Yes`,
                  $localize`Yes`,
                ]
              ]
            ] : [])
          ],
        },
        id: 'exit',
        footerItems: [
          "*With survey permission.",
          "† Offering a restricted view of requests for all products.",
          "‡ Only for the product they have access to"
        ]
      },
      {
        title: $localize`Background check permissions`,
        img: 'https://assets.xref.com/omni/shared/background_check.svg',
        table_content: {
          headers: [
            $localize`Features`,
            $localize`Administrator`,
            $localize`Requestor`,
            $localize`Contributor`,
          ],
          body: [
            [
              [$localize`Settings`, '', '', ''],
              [$localize`Trust Marketplace settings`, $localize`Yes`, '-', '-'],
              [$localize`User management`, $localize`Yes‡`, '-', '-'],
            ],
            [
              [$localize`Requests`, '', '', ''],
              [
                $localize`Send requests`,
                $localize`Yes`,
                $localize`Yes`,
                $localize`Yes`,
              ],
              [
                $localize`View requests`,
                $localize`All requests`,
                $localize`All requests`,
                $localize`Own requests`,
              ]
            ],
            [
              [$localize`People`, '', '', ''],
              [
                $localize`View profile`,
                $localize`Yes†`,
                $localize`Yes†`,
                $localize`Yes†`,
              ],
              [$localize`Edit profile`, $localize`Yes`, $localize`Yes`, '-'],
            ],
            ...(isPulseRelaunchActive ? [
              [
                [$localize`Generate report`, '', '', '', ''],
                [
                  $localize`Talent pool`,
                  $localize`Yes`,
                  $localize`Yes`,
                  $localize`Yes`,
                ]
              ]
            ] : [])
          ],
        },
        id: 'background',
        footerItems: [
          "† Offering a restricted view of requests for all products.",
          "‡ Only for the product they have access to"
        ]
      },
      {
        title: $localize`Integration permissions`,
        img: 'https://assets.xref.com/omni/shared/integration_logo.svg',
        table_content: {
          headers: [$localize`Features`, $localize`Integration user`],
          body: [
            [
              [$localize`Requests`, ''],
              [$localize`Send requests`, $localize`-`],
              [$localize`View requests`, $localize`Own requests*`],
              [$localize`Manage requests`, $localize`Own requests*`],
            ],
            [
              [$localize`People`, ''],
              [$localize`View profile`, $localize`Yes†`],
              [$localize`Edit profile`, '-'],
            ],...(isPulseRelaunchActive ? [
              [
                [$localize`Generate report`, '', '', '', ''],
                [
                  $localize`Talent pool`,
                  $localize`Yes`,
                ]
              ]
            ] : [])
          ],
        },
        id: 'integration',
        footerItems: [
          "*Reference requests originating from an integration.",
          "† Offering a restricted view of requests for all products."
        ]
      },
      ...(isPulseRelaunchActive ? [
        {
          title: $localize`AI settings`,
          img: 'https://assets.xref.com/omni/shared/ai_product_logo.svg',
          table_content: {
            headers: [
              $localize`Features`,
              $localize`Administrator`,
              $localize`Requestor`,
              $localize`Contributor`,
              $localize`Analyst`,
            ],
            body: [
              [
                [$localize`Settings`, '', '', '', ''],
                [
                  $localize`AI support`,
                  $localize`Yes`,
                  $localize`-`,
                  $localize`-`,
                  $localize`-`,
                ],
                [
                  $localize`AI summaries for reference`,
                  $localize`Yes*`,
                  $localize`-`,
                  $localize`-`,
                  $localize`-`,
                ],
                [
                  $localize`AI summaries for pulse`,
                  $localize`Yes*`,
                  $localize`-`,
                  $localize`-`,
                  $localize`-`,
                ]
              ]
            ],
          },
          id: 'aisummaries',
          footerItems: [
            "*Only with Reference product access"
          ]
        },
      ] : []),
    ],
  };
}

